import { DefaultCamasysPortion } from '../types';

export const defaultCamasysPortions: ReadonlyArray<DefaultCamasysPortion> = [
  { id: 2, description: 'Small (350g)' },
  { id: 1, description: 'Medium (450g)' },
  { id: 3, description: 'Large (600g)' }
];

export const getDefaultPortion = (portionId?: number) => {
  return defaultCamasysPortions.find((portion) => portion.id === portionId) || null;
};
